import Vue from 'vue'
import Router from 'vue-router'
import Customers from './views/customer/Customers.vue'
import Detail from './views/customer/Detail.vue'
import BindFirst from './views/error/BindFirst.vue'
import { getToken, setToken, removeToken } from '@/utils/auth'

const T = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiIsImp0aSI6IjRmMWcyM2ExMmFhIn0.eyJpc3MiOiJodHRwczpcL1wvd3d3Lmdvb2tpLmNvbSIsImF1ZCI6Imh0dHBzOlwvXC93d3cuZ29va2kuY29tIiwianRpIjoiNGYxZzIzYTEyYWEiLCJpYXQiOjE1NDgwNzU1MDEsImV4cCI6MTU1MDY2NzUwMSwiY29tcGFueV9pZCI6MTAwMDA5LCJjb21wYW55X3VzZXJfaWQiOiJvTlB1MTFMTTAtN3VmTGZtMjRiQTd1NlRSOHh3IiwidHlwZSI6Ind4In0.1CTMfr1wFAcfQNV2KSfOpBo87WhNAUMh_q60qdb4vcw'
const url = BASE_API.PHP
Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/customerlist',
      name: 'customerlist',
      component: Customers,
    },
    {
      path: '/customer/detail/:id/:call_time',
      name: 'detail',
      component: Detail,
    },
    {
      path: '/error/bindfirst',
      name: 'bindfirst',
      component: BindFirst,
    },
  ],
})

router.beforeEach((to, from, next) => {
  // alert(to.query.token)
  // removeToken()
  // return
  if (to.name !== 'detail' && to.name !== 'customerlist') {
    next()
    return
  }
  // console.log()
  const paramToken = to.query.token
  if (paramToken) {
    setToken(paramToken)
    next()
  } else {
    const localToken = getToken()
    if (localToken) {
      next()
    } else {
      // window.location.href = `https://dev-api-wx.gooki.com/customerlist?token=${T}`
      window.location.href = `${url}/wechat/access`
    }
  }
})

export default router
